import { REGION_MAP } from '@sailor/compass';
import { LocatinStatus } from '@/src/sub_packages/homepage/address_bar/constant';

// 默认定位点提取自 choose_location_page/constant.ts；源文件未提供 MG、OM，调用方继续回退 HK。
export const DefaultLocation = {
  [REGION_MAP.HK]: {
    // actualLatitude: '22.3203648',
    // actualLongitude: '114.169773',
    channelId: 'banner-10002',
    latitude: 22.3203648,
    longitude: 114.169773,
    cityId: 810001,
    city: 'Hong Kong',
    region: REGION_MAP.HK,
    country: REGION_MAP.HK,
    countryCode: REGION_MAP.HK,
    timezone: 'GMT+08:00',
    timezoneOffset: 480,
    timezoneName: 'Hong Kong Standard Time',
    locateStatus: LocatinStatus.defauleLocation,
  },
  [REGION_MAP.KW]: {
    channelId: 'banner-10002',
    latitude: 29.377711,
    longitude: 47.975956,
    cityId: 109100007,
    city: 'Kuwait City',
    region: REGION_MAP.KW,
    country: REGION_MAP.KW,
    countryCode: REGION_MAP.KW,
    locateStatus: LocatinStatus.defauleLocation,
  },
  [REGION_MAP.QA]: {
    channelId: 'banner-10002',
    latitude: 25.274983,
    longitude: 51.531562,
    cityId: 114000008,
    city: 'Doha',
    region: REGION_MAP.QA,
    country: REGION_MAP.QA,
    countryCode: REGION_MAP.QA,
    locateStatus: LocatinStatus.defauleLocation,
  },
  [REGION_MAP.SA]: {
    channelId: 'banner-10002',
    latitude: 24.638916,
    longitude: 46.7160104,
    cityId: 1150000081,
    city: 'Riyadh',
    region: REGION_MAP.SA,
    country: REGION_MAP.SA,
    countryCode: REGION_MAP.SA,
    locateStatus: LocatinStatus.defauleLocation,
  },
  [REGION_MAP.AE]: {
    channelId: 'banner-10002',
    latitude: 25.073275,
    longitude: 55.245006,
    cityId: 118200003,
    city: 'Dubai',
    region: REGION_MAP.AE,
    country: REGION_MAP.AE,
    countryCode: REGION_MAP.AE,
    locateStatus: LocatinStatus.defauleLocation,
  },
  [REGION_MAP.BH]: {
    channelId: 'banner-10002',
    latitude: 26.239651,
    longitude: 50.581259,
    cityId: 101200005,
    city: 'Manama',
    region: REGION_MAP.BH,
    country: REGION_MAP.BH,
    countryCode: REGION_MAP.BH,
    locateStatus: LocatinStatus.defauleLocation,
  },
  [REGION_MAP.BR]: {
    channelId: 'banner-10002',
    latitude: -23.5489841,
    longitude: -46.6332165,
    cityId: 102302389,
    city: 'Sao Paulo',
    region: REGION_MAP.BR,
    country: REGION_MAP.BR,
    countryCode: REGION_MAP.BR,
    locateStatus: LocatinStatus.defauleLocation,
  },
};
